var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verification-selector" }, [
    _c(
      "div",
      {
        staticClass:
          "container container_40 verification-selector__item selector-item"
      },
      [
        _c(
          "div",
          { staticClass: "selector-item__header" },
          [
            _c("span", { staticClass: "text_large" }, [
              _vm._v(_vm._s(_vm.i18n.kyc_general()))
            ]),
            _vm._v(" "),
            _c(
              "md-icon",
              [
                _vm._v("\n              info\n              "),
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v(_vm._s(_vm.i18n.kyc_inv_tip()))
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selector-item__content" },
          [
            _c("md-icon", { staticClass: "md-size-5x md-medium-size-3x" }, [
              _vm._v("person")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-wrap margin-top" },
          [
            _c(
              "md-button",
              {
                staticClass: "btn md-primary",
                on: {
                  click: function($event) {
                    return _vm.setType(_vm.KYC_USER_TYPE.general)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.i18n.kyc_submit()))]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "container container_40 verification-selector__item selector-item"
      },
      [
        _c(
          "div",
          { staticClass: "selector-item__header" },
          [
            _c("span", { staticClass: "text_large" }, [
              _vm._v(_vm._s(_vm.i18n.kyc_corporate()))
            ]),
            _vm._v(" "),
            _c(
              "md-icon",
              [
                _vm._v("\n              info\n              "),
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v(_vm._s(_vm.i18n.kyc_corporate_tip()))
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selector-item__content" },
          [
            _c(
              "md-icon",
              {
                staticClass:
                  "md-size-5x md-medium-size-3x user-type-selector__user-type-icon"
              },
              [_vm._v("domain")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-wrap margin-top" },
          [
            _c(
              "md-button",
              {
                staticClass: "btn md-primary",
                on: {
                  click: function($event) {
                    return _vm.setType(_vm.KYC_USER_TYPE.syndicate)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.i18n.kyc_submit()))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-150396a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150396a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/make/Verification.Selector.vue
// module id = wjTo
// module chunks = 1